// Demo data seeder — pre-loads real Sturdfix reference parts on first launch
import { Job } from './store';
import { generateSequence, selectTemplate, matchMachines } from './engineeringRules';

const DEMO_PARTS: Omit<Job, 'id' | 'created_at' | 'updated_at'>[] = [
  {
    status: 'APPROVED',
    customer: 'APA Engineering',
    part_no: '54-96B',
    description: 'Cylinder Head Bolt M12×1.75×132 Grade 10.9',
    part: {
      part_type: 'BOLT', nominal_diameter_mm: 12, thread_pitch_mm: 1.75,
      total_length_mm: 132, shank_length_mm: 100,
      head_type: 'HEX_SOCKET', socket_type: 'HEX_SOCKET',
      wire_diameter_mm: 11.71, blank_length_mm: 134.5,
      weight_grams: 112.98, material_id: '10B30',
      thread_system: 'METRIC',
    },
    selected_machine: 'SJBF_134L',
    engineer_notes: 'Template A. L/D 11.5. 9° cone rule confirmed.',
  },
  {
    status: 'APPROVED',
    customer: 'APA Engineering',
    part_no: '80-22B',
    description: 'Hex Flange Drain Plug M14×1.50P',
    part: {
      part_type: 'BOLT', nominal_diameter_mm: 14, thread_pitch_mm: 1.5,
      total_length_mm: 34, shank_length_mm: 15,
      head_type: 'HEX_FLANGE', socket_type: 'HEX_SOCKET',
      has_flange: true,
      wire_diameter_mm: 12.79, blank_length_mm: 34.0,
      weight_grams: 36.97, material_id: 'SAE1008',
      thread_system: 'METRIC',
    },
    selected_machine: 'SJBF_134L',
    engineer_notes: 'Template B. L/D 2.7. Carbide pallet Stn 4 (dome + SFX logo).',
  },
  {
    status: 'APPROVED',
    customer: 'LEDERER',
    part_no: '09166140025-01',
    description: 'Hex Socket Set Screw M14×2.0×25 DIN-916',
    part: {
      part_type: 'BOLT', nominal_diameter_mm: 14, thread_pitch_mm: 2.0,
      total_length_mm: 25,
      head_type: 'NONE', socket_type: 'HEX_SOCKET',
      wire_diameter_mm: 12.49, blank_length_mm: 22.5,
      material_id: 'SCM435', thread_system: 'METRIC',
    },
    selected_machine: 'SJBF_164S',
    engineer_notes: 'Template C. Stripper mechanism mandatory. M42 hex punch.',
  },
  {
    status: 'APPROVED',
    customer: 'WOOTZWORK',
    part_no: 'WOOTZ2097793',
    description: 'Special Hex Bolt with Serration M10×22.50 F/T Grade 8.8',
    part: {
      part_type: 'BOLT', nominal_diameter_mm: 10, thread_pitch_mm: 1.5,
      total_length_mm: 22.5,
      head_type: 'HEX_FLANGE', socket_type: 'NONE',
      has_flange: true, has_serration: true,
      wire_diameter_mm: 9.475, blank_length_mm: 45.5,
      weight_grams: 22.65, material_id: '15B25',
      thread_system: 'METRIC',
    },
    selected_machine: 'SJBF_134L',
    engineer_notes: 'Template B-S. 9° cone. 36 ribs. Hex + serration form simultaneously Stn 3.',
  },
  {
    status: 'APPROVED',
    customer: 'Sturdfix',
    part_no: '093414-8Z1',
    description: 'DIN 934 Hex Nut M14×2.0P-6G Grade 8 Zinc Plated',
    part: {
      part_type: 'NUT', nominal_diameter_mm: 14, thread_pitch_mm: 2.0,
      total_length_mm: 12.8,
      nut_height_mm: 12.8, nut_af_mm: 22.0,
      wire_diameter_mm: 14.5, material_id: 'SAE1022',
      thread_system: 'METRIC',
    },
    selected_machine: 'SN_24B6S',
    engineer_notes: 'Template D2. Hex forms Stn 2. Active KO Stns 4+5.',
  },
  {
    status: 'APPROVED',
    customer: 'Sturdfix',
    part_no: 'TAA27076JB15-5',
    description: 'DIN 6923 Serrated Flange Nut M8×1.25P-6G Height 9 Grade 8',
    part: {
      part_type: 'NUT', nominal_diameter_mm: 8, thread_pitch_mm: 1.25,
      total_length_mm: 9,
      nut_height_mm: 9, nut_af_mm: 14.0,
      has_flange: true, has_serration: true,
      wire_diameter_mm: 8.5, material_id: 'SAE1022',
      thread_system: 'METRIC',
    },
    selected_machine: 'SN_14B6S',
    engineer_notes: 'Template D1. Hex forms Stn 3. Sleeve+pin Stn 5.',
  },
];

export function seedDemoData(addJob: (job: any) => string, updateJob: (id: string, updates: any) => void) {
  DEMO_PARTS.forEach(partJob => {
    if (!partJob.part) return;
    const { template } = selectTemplate(partJob.part);
    const machine = partJob.selected_machine as any;
    const seq = generateSequence(partJob.part, machine);
    const id = addJob(partJob);
    updateJob(id, { sequence: seq });
  });
}
